import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';

import Start from './modals/Start'
import CreateCertificate from './modals/CreateCertificate'
import TAN from './modals/TAN'
import Signature from './modals/Signature'
import Confirmation from './modals/Confirmation'
import Logo from '../components/Logo';
import PrimaryButton from '../components/PrimaryButton';
import { has } from 'ramda';

const handleLogout = history => () => {
    firebase.auth().signOut()
        .then(() => history.push('/login'));
}

class Dashboard extends Component {
    constructor(props) {
        super(props);
        
        const { location } = this.props;

        if (location.pathname === '/dashboard/start' && !location.state) {
            this.handleLogout();
        }
    }

    handleLogout = () => {
        firebase.auth().signOut()
            .then(() => this.props.history.push('/login'));
    }

    render() {
        const user = firebase.auth().currentUser;
        const { match, history, location } = this.props;

        return (
            <>
                <div className='modal-container'>
                    <Route path={`${match.url}/start`} component={Start} />
                    <Route path={`${match.url}/certificate`} component={props => (
                        <CreateCertificate
                            {...props}
                            user={user}
                        />
                    )} />
                    <Route path={`${match.url}/tan`} component={TAN} />
                    <Route path={`${match.url}/signature`} component={Signature} />
                    <Route path={`${match.url}/confirmation`} component={Confirmation} />
                </div>
                <div className='dashboard'>
                    <div className='header'>
                        <Logo className='logo--title' />
                        <PrimaryButton
                            title='Abmelden'
                            className='button--secondary'
                            onClick={handleLogout(history)}
                        />
                    </div>
                    <div className='content'>
                        <h1 className='content__title'>
                            Herzlich Willkommen, {user.displayName}!
                    </h1>
                        <div class='hero'>
                            <p>
                                Gesamtsaldo Ihrer Konten
                        </p>
                            <p>
                                <strong>
                                    {(location.search && location.search === '?success=true')
                                        ? '22.736,73 €'
                                        : '2.736,73 €'
                                    }
                                </strong>
                            </p>
                        </div>
                        <h2 className='content__subtitle'>
                            Ihre Kontenübersicht
                    </h2>
                        <div className='accounts'>
                            <div className='account'>
                                <ion-icon name="cash" class='account__icon'></ion-icon>
                                <div className='account__details'>
                                    <h3 className='account__title'>Girokonto</h3>
                                    DE41 5001 0517 0123 4567 89
                            </div>
                                <div className='account__saldo'>
                                    {(location.search && location.search === '?success=true')
                                        ? '18.871,88 €'
                                        : '-1.128,12 €'
                                    }
                                </div>
                            </div>
                            <div className='account'>
                                <ion-icon name="card" class='account__icon'></ion-icon>
                                <div className='account__details'>
                                    <h3 className='account__title'>Visa Kreditkarte</h3>
                                    7783 3848 3765 4993
                            </div>
                                <div className='account__saldo'>-374,08 €</div>
                            </div>
                            <div className='account'>
                                <ion-icon name="analytics" class='account__icon'></ion-icon>
                                <div className='account__details'>
                                    <h3 className='account__title'>Depot</h3>
                                    0123 4567 89
                            </div>
                                <div className='account__saldo'>4.238,93 €</div>
                            </div>
                        </div>
                    </div>
                    <div className='footer-container'>
                        <footer className='footer'>
                            <p>&copy; 2019 Theresienbank</p>
                            <ul className='footernav'>
                                <li className='footernav__item'>
                                    Kontakt
                            </li>
                                <li className='footernav__item'>
                                    Impressum
                            </li>
                            </ul>
                        </footer>
                    </div>
                </div>
            </>
        )
    }
}

export default Dashboard;
